/**
 * DD-BE-PR1: paginated PR1 payloads for D&D queue hydrate.
 * Gated by products_design.queue.view (not sales.workflow.view).
 */
import type { AxiosRequestConfig } from 'axios'
import apiService from '@/services/api'

const INTAKE_ENDPOINT = '/v1/design-development/queue-intake'

const STRICT_SUCCESS_HTTP: AxiosRequestConfig = {
  validateStatus: (status) => status >= 200 && status < 300,
}

export type DesignDevelopmentQueueIntakeTile =
  | 'new_product'
  | 'new_product_bundle'
  | 'new_order'
  | 'modify_product'
  | 'discontinue_replace'

export interface DesignDevelopmentQueueIntakeItem {
  uuid: string
  origin_ref: string
  tile: DesignDevelopmentQueueIntakeTile
  submitted_at: string
  /** DD-DUE-24H-002 — server ingest stamp (pre-line fallback). */
  due_at?: string | null
  /** Stripped Origin JSON (SYS-011 — no attachment dataUrl). */
  payload: Record<string, unknown>
}

export interface DesignDevelopmentQueueIntakeMeta {
  current_page: number
  last_page: number
  per_page: number
  total: number
}

interface DesignDevelopmentQueueIntakeEnvelope {
  success: boolean
  data: DesignDevelopmentQueueIntakeItem[]
  meta: DesignDevelopmentQueueIntakeMeta
}

function assertSuccess(body: unknown): asserts body is DesignDevelopmentQueueIntakeEnvelope {
  const envelope = body as DesignDevelopmentQueueIntakeEnvelope
  if (!envelope?.success || !Array.isArray(envelope.data) || !envelope.meta) {
    throw new Error('Failed to load design-development queue intake')
  }
}

export async function fetchDesignDevelopmentQueueIntake(
  page = 1,
  perPage = 100
): Promise<DesignDevelopmentQueueIntakeEnvelope> {
  const response = await apiService.get<DesignDevelopmentQueueIntakeEnvelope>(INTAKE_ENDPOINT, {
    params: { page, per_page: perPage },
    ...STRICT_SUCCESS_HTTP,
  })
  assertSuccess(response)
  return response
}
